module.exports = __webpack_public_path__ + "img/noLogo.f76e35.png";